// redux/sagas/dashboardSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getHoldingsRequest,
  getHoldingsSuccess,
  getHoldingsFailure,
  getBullionRatesRequest,
  getBullionRatesSuccess,
  getBullionRatesFailure,
  getAppConfigRequest,
  getAppConfigSuccess,
  getAppConfigFailure,
  getCarouselRequest,
  getCarouselSuccess,
  getCarouselFailure,
  getSipBalanceRequest,
  getSipBalanceSuccess,
  getSipBalanceFailure,
  getKycDetailsRequest,
  getKycDetailsSuccess,
  getKycDetailsFailure,
  getStoreListForUserRequest,
  getStoreListForUserSuccess,
  getStoreListForUserFailure,
  getDiamondPointsRequest,
  getDiamondPointsSuccess,
  getDiamondPointsFailure,
  getActiveConfigurationsRequest,
  getActiveConfigurationsSuccess,
  getActiveConfigurationsFailure,
  getActiveOffersRequest,
  getActiveOffersSuccess,
  getActiveOffersFailure,
  getActiveCountriesRequest,
  getActiveCountriesSuccess,
  getActiveCountriesFailure,
  getActiveAppThemeRequest,
  getActiveAppThemeSuccess,
  getActiveAppThemeFailure,
} from "./dashboardSlice";
import { toast } from "react-toastify";

function* fetchHoldings(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getHoldings`,
        payload
      )
    );

    if (response.data.success) {
      yield put(getHoldingsSuccess(response.data));
      // toast.success("Holdings fetched successfully");
    } else {
      yield put(
        getHoldingsFailure(response.data.message || "Failed to fetch holdings")
      );
      toast.error(response.data.message || "Failed to fetch holdings");
    }
  } catch (error) {
    yield put(getHoldingsFailure(error.message));
    toast.error("Error fetching holdings");
  }
}

function* fetchBullionRates(action) {
  try {
    const jewellerId = action.payload?.id;
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-rates/getBullionRates/${jewellerId}`
      )
    );

    if (response.data.success) {
      yield put(getBullionRatesSuccess(response.data));
      // toast.success("Bullion rates fetched successfully");
    } else {
      yield put(
        getBullionRatesFailure(
          response.data.message || "Failed to fetch bullion rates"
        )
      );
      toast.error(response.data.message || "Failed to fetch bullion rates");
    }
  } catch (error) {
    yield put(getBullionRatesFailure(error.message));
    toast.error("Error fetching bullion rates");
  }
}

function* fetchAppConfig(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getAppConfig`
      )
    );

    if (response.data.success) {
      yield put(getAppConfigSuccess(response.data));
      // toast.success("App configuration fetched successfully");
    } else {
      yield put(
        getAppConfigFailure(
          response.data.message || "Failed to fetch app configuration"
        )
      );
      toast.error(response.data.message || "Failed to fetch app configuration");
    }
  } catch (error) {
    yield put(getAppConfigFailure(error.message));
    toast.error("Error fetching app configuration");
  }
}

function* fetchCarousel() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/carousel/getcarouselformobile`
      )
    );

    if (response.data.success) {
      yield put(getCarouselSuccess(response.data));
      // toast.success("Carousel fetched successfully");
    } else {
      yield put(
        getCarouselFailure(response.data.message || "Failed to fetch carousel")
      );
      toast.error(response.data.message || "Failed to fetch carousel");
    }
  } catch (error) {
    yield put(getCarouselFailure(error.message));
    toast.error("Error fetching carousel");
  }
}

function* fetchSipBalance(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getSipBalance`
      )
    );

    if (response.data.success) {
      yield put(getSipBalanceSuccess(response.data));
      // toast.success("SIP balance fetched successfully");
    } else {
      yield put(
        getSipBalanceFailure(
          response.data.message || "Failed to fetch SIP balance"
        )
      );
      // toast.error(response.data.message || "Failed to fetch SIP balance");
    }
  } catch (error) {
    yield put(getSipBalanceFailure(error.message));
    toast.error("Error fetching SIP balance");
  }
}

function* fetchKycDetails(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/getkycdetails`
      )
    );

    if (response.data.success) {
      yield put(getKycDetailsSuccess(response.data));
      console.log("response.data", response.data);
      // toast.success("KYC details fetched successfully");
    } else {
      yield put(
        getKycDetailsFailure(
          response.data.message || "Failed to fetch SIP balance"
        )
      );
      toast.error(response.data.message || "Failed to fetch SIP balance");
    }
  } catch (error) {
    yield put(getKycDetailsFailure(error.message));
    toast.error("Error fetching SIP balance");
  }
}

function* fetchStoreListForUser(action) {
  try {
    const jewellerId = action.payload?.id;
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/getStoreListForUser/${jewellerId}`
      )
    );

    if (response.data.success) {
      yield put(getStoreListForUserSuccess(response.data));
      // toast.success("Store list fetched successfully");
    } else {
      yield put(getStoreListForUserFailure(response.data.message));
      toast.error(response.data.message || "Stores not available");
    }
  } catch (error) {
    yield put(getStoreListForUserFailure(error.message));
    toast.error("Error fetching store list");
  }
}

function* fetchDiamondPoints() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/getdiamondpoints`
      )
    );

    if (response.data.success) {
      yield put(getDiamondPointsSuccess(response.data));
    } else {
      yield put(
        getDiamondPointsFailure(
          response.data.message || "Failed to fetch diamond points"
        )
      );
      toast.error(response.data.message || "Failed to fetch diamond points");
    }
  } catch (error) {
    yield put(getDiamondPointsFailure(error.message));
    toast.error("Error fetching diamond points");
  }
}

function* fetchActiveConfigurations() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/diamond-point/get-active-configurations`
      )
    );

    if (response.data.success) {
      yield put(getActiveConfigurationsSuccess(response.data));
    } else {
      yield put(
        getActiveConfigurationsFailure(
          response.data.message || "Failed to fetch active configurations"
        )
      );
      toast.error(
        response.data.message || "Failed to fetch active configurations"
      );
    }
  } catch (error) {
    yield put(getActiveConfigurationsFailure(error.message));
    toast.error("Error fetching active configurations");
  }
}

function* fetchActiveOffers() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/offer/getActiveOffers`
      )
    );

    if (response.data.success) {
      yield put(getActiveOffersSuccess(response.data));
    } else {
      yield put(
        getActiveOffersFailure(
          response.data.message || "Failed to fetch active offers"
        )
      );
      toast.error(response.data.message || "Failed to fetch active offers");
    }
  } catch (error) {
    yield put(getActiveOffersFailure(error.message));
    toast.error("Error fetching active offers");
  }
}

function* getActiveCountriesSaga({ payload }) {
  try {
    const token = `${process.env.REACT_APP_PUBLIC_TOKEN}`;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/get-active-countries`,
        payload
      )
    );

    if (response.data.success) {
      yield put(getActiveCountriesSuccess(response.data.data));
      //  toast.success(response.data.message || "Fetched active countries!");
    } else {
      yield put(getActiveCountriesFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch countries!");
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(getActiveCountriesFailure(message));
    toast.error(`Failed to fetch active countries: ${message}`);
  }
}

function* getActiveAppThemeSaga({ payload }) {
  try {
    const token = `${process.env.REACT_APP_PUBLIC_TOKEN}`;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/app-theme/get-theme`,
        payload
      )
    );

    if (response.data.success) {
      yield put(getActiveAppThemeSuccess(response.data.data));
      //  toast.success(response.data.message || "Fetched active countries!");
    } else {
      yield put(getActiveAppThemeFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch app theme!");
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(getActiveAppThemeFailure(message));
    toast.error(`Failed to fetch active app theme: ${message}`);
  }
}

export function* dashboardSaga() {
  yield takeLatest(getHoldingsRequest.type, fetchHoldings);
  yield takeLatest(getBullionRatesRequest.type, fetchBullionRates);
  yield takeLatest(getAppConfigRequest.type, fetchAppConfig);
  yield takeLatest(getCarouselRequest.type, fetchCarousel);
  yield takeLatest(getSipBalanceRequest.type, fetchSipBalance);
  yield takeLatest(getKycDetailsRequest.type, fetchKycDetails);
  yield takeLatest(getStoreListForUserRequest.type, fetchStoreListForUser);
  yield takeLatest(getDiamondPointsRequest.type, fetchDiamondPoints);
  yield takeLatest(
    getActiveConfigurationsRequest.type,
    fetchActiveConfigurations
  );
  yield takeLatest(getActiveOffersRequest.type, fetchActiveOffers);
  yield takeLatest(getActiveCountriesRequest.type, getActiveCountriesSaga);
    yield takeLatest(getActiveAppThemeRequest.type, getActiveAppThemeSaga);
}
